export enum DefaultValues {
    DEFAULT_DATE = "--/--/----",
    DEFAULT_TIME = "--:--", 
    DEFAULT_TEXT = "",
    NOT_DATA = "--"
}